import { Fragment, useState } from "react";
import uuid from "react-uuid";
import Nestable from "react-nestable";
import { Card, Tooltip, Button } from "@material-tailwind/react";
//Form Elements
import { RadioInput } from "./elements";
import { formEl } from "./constants.js";
//Components
import Header from "./Header";
import TextFieldNew from "./elements/TextFieldNew";
import CheckBoxInput from "./elements/CheckBoxInput";
import DropdownInput from "./elements/DropdownInput";
import SliderInput from "./elements/SliderInput";
import { useMutation } from "react-query";
import { Link } from "react-router-dom";
import { httpMushPro } from "../../services/http-common";
import { dropdownOptionsForm } from "../SeekerForm/dropdownOptionsForm";
import { toast } from "react-toastify";
import { ArrowLeftIcon } from "@heroicons/react/24/outline";

const FormBuilder = () => {
  const initVal = formEl[0]?.value;

  //State
  const [title, setTitle] = useState("Untitled Form");
  const [description, setDescription] = useState("");
  const [data, setData] = useState([]);
  const [formData, setFormData] = useState("text");
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const items = data;

  //Function to add new element
  const addElement = () => {
    const data = {
      id: uuid(),
      value: null,
      type: formData,
      required: false,
      content: "",
      saved: false,
    };
    setData((prevState) => [...prevState, data]);
    setFormData(initVal);
  };

  //Function to delete element
  const deleteEl = (id) => {
    setData((prevState) => prevState.filter((val) => val.id !== id));
  };

  //Function to add element at specific pos and return arr
  const addAfter = (elArray, index, newEl) => {
    return [...elArray.slice(0, index + 1), newEl, ...elArray.slice(index + 1)];
  };

  //Function to duplicate element
  const duplicateElement = (elId, elType) => {
    let elIdx = data.findIndex((el) => el.id === elId);
    let newEl = {
      id: uuid(),
      value: null,
      type: elType,
      required: false,
    };
    let newArr = addAfter(data, elIdx, newEl);
    setData(newArr);
  };

  //Function to handle sorting of elements
  const handleOnChangeSort = ({ items }) => {
    setData(items);
  };

  //Function to Handle Input Values
  const handleValue = (id, e) => {
    let newArr = data.map((el) => {
      if (el.id === id) {
        return { ...el, value: e.target.value, content: "" };
      } else {
        return el;
      }
    });
    setData(newArr);
  };
  // Function to handle Slider
  const handleSliderValue = (id, e, name) => {
    let newArr = data.map((el) => {
      if (el.id === id) {
        return { ...el, [name]: Number(e.target.value), content: "" };
      } else {
        return el;
      }
    });
    console.log(newArr);
    setData(newArr);
  };

  //Function to Handle Required
  const handleRequired = (id) => {
    let newArr = data.map((el) => {
      if (el.id === id) {
        return { ...el, required: !el.required };
      } else {
        return el;
      }
    });
    setData(newArr);
  };
  //Function to Save
  const handleSave = (id) => {
    let newArr = data.map((el) => {
      if (el.id === id) {
        return { ...el, saved: !el.saved };
      } else {
        return el;
      }
    });
    setData(newArr);
  };

  //Function to Handle Element Type
  const handleElType = (id, type) => {
    let newArr = data.map((el) => {
      if (el.id === id) {
        console.log(type);
        return {
          ...el,
          type: type,
          options:
            type === "radio" || type === "checkbox" || type === "dropdown"
              ? [
                  {
                    id: uuid(),
                    value: null,
                  },
                  {
                    id: uuid(),
                    value: null,
                  },
                  {
                    id: uuid(),
                    value: null,
                  },
                  {
                    id: uuid(),
                    value: null,
                  },
                ]
              : null, // Add default options if type is radio
        };
      } else {
        return el;
      }
    });
    setData(newArr);
  };

  //Function to Handle Options
  const addOption = (id, newOption) => {
    let newArr = data.map((el) => {
      if (el.id === id) {
        const objVal = "options" in el ? el?.options : [];
        return { ...el, options: [...objVal, newOption] };
      } else {
        return el;
      }
    });
    setData(newArr);
  };

  //Function to Change Option Values
  const handleOptionValues = (elId, optionId, optionVal) => {
    let newArr = data.map((el) => {
      if (el.id === elId) {
        el?.options &&
          el?.options.map((opt) => {
            if (opt.id === optionId) {
              opt.value = optionVal;
            }
          });
        return el;
      } else {
        return el;
      }
    });
    setData(newArr);
  };
  const filterByValue = (value) => {
    return dropdownOptionsForm.filter((option) => option.value === value);
  };
  //Function to Change Option Values
  const handleDefaultOptionValues = (elId, values) => {
    let selectedDataOptions = filterByValue(values)[0].options;
    console.log(selectedDataOptions);

    let newArr = data.map((el) => {
      if (el.id === elId) {
        // Update existing options and add new ones if necessary
        selectedDataOptions.forEach((optValue, idx) => {
          if (el.options[idx]) {
            el.options[idx].value = optValue;
          } else {
            el.options = [...el.options, { id: uuid(), value: optValue }];
          }
        });

        // Remove extra options if selectedDataOptions has fewer values
        if (el.options.length > selectedDataOptions.length) {
          el.options = el.options.slice(0, selectedDataOptions.length);
        }

        console.log(el.options);
        return el;
      } else {
        return el;
      }
    });
    setData(newArr);
  };

  //Function to Delete Option
  const deleteOption = (elId, optionId) => {
    let newArr = data.map((el) => {
      if (el.id === elId) {
        let newOptions =
          el?.options && el?.options.filter((opt) => opt.id !== optionId);
        return { ...el, options: newOptions };
      } else {
        return el;
      }
    });
    setData(newArr);
  };

  const createForm = useMutation(
    () => {
      return httpMushPro.post("user/intake-form/create", {
        title: title,
        description: description,
        formData: data,
      });
    },
    {
      onSuccess: ({ data }) => {
        console.log(data);
        toast.success("Form Created Successfully");
      },
      onError: (error) => {
        toast.error(error.response.data.message);
      },
    }
  );
  const handleSubmit = () => {
    createForm.mutate();
  };

  //Render items
  const renderElements = ({ item, index }) => {
    switch (item.type) {
      case "text":
        return (
          <TextFieldNew
            item={item}
            index={index}
            handleValue={handleValue}
            deleteEl={deleteEl}
            handleRequired={handleRequired}
            handleElType={handleElType}
            duplicateElement={duplicateElement}
            addElement={addElement}
            handleSave={handleSave}
          />
        );
      case "checkbox":
        return (
          <CheckBoxInput
            item={item}
            index={index}
            handleValue={handleValue}
            deleteEl={deleteEl}
            handleRequired={handleRequired}
            handleElType={handleElType}
            addOption={addOption}
            handleOptionValues={handleOptionValues}
            deleteOption={deleteOption}
            duplicateElement={duplicateElement}
            handleSave={handleSave}
          />
        );

      case "dropdown":
        return (
          <DropdownInput
            item={item}
            index={index}
            handleDefaultOptionValues={handleDefaultOptionValues}
            handleValue={handleValue}
            deleteEl={deleteEl}
            handleRequired={handleRequired}
            handleElType={handleElType}
            addOption={addOption}
            handleOptionValues={handleOptionValues}
            deleteOption={deleteOption}
            duplicateElement={duplicateElement}
            handleSave={handleSave}
          />
        );
      case "radio":
        return (
          <RadioInput
            item={item}
            index={index}
            handleValue={handleValue}
            deleteEl={deleteEl}
            handleRequired={handleRequired}
            handleElType={handleElType}
            handleDefaultOptionValues={handleDefaultOptionValues}
            addOption={addOption}
            handleOptionValues={handleOptionValues}
            deleteOption={deleteOption}
            duplicateElement={duplicateElement}
            handleSave={handleSave}
          />
        );
      case "slider":
        return (
          <SliderInput
            item={item}
            index={index}
            handleValue={handleValue}
            handleSliderValue={handleSliderValue}
            deleteEl={deleteEl}
            handleRequired={handleRequired}
            handleElType={handleElType}
            handleDefaultOptionValues={handleDefaultOptionValues}
            addOption={addOption}
            handleOptionValues={handleOptionValues}
            deleteOption={deleteOption}
            duplicateElement={duplicateElement}
            handleSave={handleSave}
          />
        );
      default:
        return <Fragment></Fragment>;
    }
  };

  return (
    <Fragment>
      <div className="container mx-auto">
        <div className="p-2">
          <Link className=" text-sm flex items-center" to="/intake-form">
            <ArrowLeftIcon className="h-4 w-4 mr-1" />
            Back
          </Link>
        </div>
        <div className="grid grid-cols-1 gap-4">
          <Header
            title={title}
            setTitle={setTitle}
            description={description}
            setDescription={setDescription}
            handleSubmit={handleSubmit}
          />
          {items.length !== 0 && (
            <Card className="p-4">
              <Nestable
                items={items}
                renderItem={renderElements}
                maxDepth={1}
                onChange={handleOnChangeSort}
              />
            </Card>
          )}
        </div>
        <div className="my-4">
          <Tooltip
            content="Add Element"
            placement="right"
            open={tooltipOpen}
            onOpen={() => setTooltipOpen(true)}
            onClose={() => setTooltipOpen(false)}
          >
            <Button
              size="sm"
              onClick={addElement}
              variant="outlined"
              color="green"
            >
              + Add Question
            </Button>
          </Tooltip>
        </div>
        <div className="my-4 flex justify-end">
          <Button size="sm" className="bg-[#000080]" onClick={handleSubmit}>
            Save Form
          </Button>
        </div>
      </div>
    </Fragment>
  );
};

export default FormBuilder;
